import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";
import { Totem } from "../../../../@types/totem";
import { toast } from "react-toastify";
import { useTotemStyles } from "../../styles";
import Info from "@material-ui/icons/Info";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";

type Props = {
    totem: Totem;
    buttonTrigger?: React.ReactNode;
};

function PopperInfo() {
    const { classes } = useAttendanceLocalMapStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <span
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                <Info />
            </span>
            <Popper
                transition
                open={open}
                anchorEl={anchorEl}
                placement="top"
                style={{ zIndex: 1501 }}
                modifiers={{
                    arrow: {
                        enabled: true,
                        element: '[data-popper-arrow]',
                    },
                }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.paper}>
                            <div
                                data-popper-arrow
                                className={classes.arrow}
                            />
                            <Typography className={classes.typography}>
                                O Token é a chave para acessar o funcionamento do Totem de Atendimento
                            </Typography>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    );
}

export default function TotemToken({ totem, buttonTrigger }: Props) {
    const [open, setOpen] = useState(false);
    const { classes: defaultClasses } = useTotemStyles();
    const { classes } = useAttendanceLocalMapStyles();

    function handleCopyToClipboard() {
        navigator.clipboard.writeText(totem.token)
            .then(() => {
                toast.success("Token copiado para a área de transferência!");
            })
            .catch(() => {
                toast.error("Erro ao copiar o token para a área de transferência.");
            });
    }

    return (
        <>
            {buttonTrigger ? (
                <span onClick={() => setOpen(true)}>
                    {buttonTrigger}
                </span>
            ) : (
                <Button
                    startIcon={<Visibility fontSize="small" />}
                    className={classes.button}
                    onClick={() => setOpen(true)}
                >
                    Visualizar Token
                </Button>
            )}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
                <Card>
                    <CardHeader
                        avatar={<Visibility />}
                        title={<Typography variant="h5">Token</Typography>}
                        className={classes.cardHeader}
                    />
                    <CardContent className={classes.cardContent}>
                        <TextField
                            fullWidth
                            label="Token"
                            value={totem?.token || ""}
                            variant="outlined"
                            inputProps={{
                                readOnly: true,
                            }}
                            InputProps={{
                                endAdornment: (
                                    <PopperInfo />
                                )
                            }}
                        />
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button
                            className={classes.button}
                            onClick={() => setOpen(false)}
                        >
                            Fechar
                        </Button>
                        <Button
                            className={defaultClasses.addButton}
                            onClick={handleCopyToClipboard}
                        >
                            Copiar
                        </Button>
                    </CardActions>
                </Card>
            </Dialog>
        </>
    );
}
